import { messenger } from "../utils/webview";

export default function useWebviewMessage() {
  const sendWebInitializeMessage = () => {
    messenger.postMessage("webInitialize");
  };
  return { sendWebInitializeMessage };
}
